class LicenseCheck {
   // check if an abstract with an given license can be displayed or not

 allowed = ["http://iopscience.iop.org/info/page/text-and-data-mining",
    "http://creativecommons.org/licenses/by-nc-nd/3.0",
    "http://creativecommons.org/licenses/by-nc-nd/3.0/",
    "http://creativecommons.org/licenses/by-nc-nd/4.0",
    "http://creativecommons.org/licenses/by-nc-nd/4.0/",
    "http://creativecommons.org/licenses/by-nc-sa/4.0",
    "http://creativecommons.org/licenses/by-nc-sa/4.0/",
    "http://creativecommons.org/licenses/by-nc/2.0/uk/",
    "http://creativecommons.org/licenses/by-nc/2.5",
    "http://creativecommons.org/licenses/by-nc/3.0/",
    "http://iopscience.iop.org/info/page/text-and-data-mining",
    "http://doi.wiley.com/10.1002/tdm_license_1",
    "http://doi.wiley.com/10.1002/tdm_license_1.1",
    "http://creativecommons.org/licenses/by-nd/4.0",
    "http://creativecommons.org/licenses/by-nd/4.0/",
    "http://creativecommons.org/licenses/by/2.0",
    "http://creativecommons.org/licenses/by/2.0/uk/legalcode",
    "http://creativecommons.org/licenses/by/3.0/",
    "http://creativecommons.org/licenses/by/3.0/deed.en_US",
    "http://creativecommons.org/licenses/by/3.0/pl/",
    "http://creativecommons.org/licenses/by/4.0",
    "http://creativecommons.org/licenses/by/4.0/",
    "http://opensource.org/licenses/AFL-3.0",
    "http://opensource.org/licenses/MIT",
    "http://press.anu.edu.au/about/conditions-use",
    "http://pubs.acs.org/page/policy/authorchoice_ccby_termsofuse.html",
    "http://pubs.acs.org/page/policy/authorchoice_ccbyncnd_termsofuse.html",
    "http://pubs.acs.org/page/policy/authorchoice_termsofuse.html",
    "http://rightsstatements.org/vocab/NoC-NC/1.0/",
    "http://rightsstatements.org/vocab/NoC-US/1.0/",
    "http://www.biologists.com/user-licence-1-1",
    "http://www.biologists.com/user-licence-1-1/",
    "http://www.bmj.com/company/legal-information/terms-conditions/legal-information/tdm-licencepolicy",
    "http://www.bmj.org/licenses/tdm/1.0/terms-and-conditions.html",
    "http://www.elsevier.com/open-access/userlicense/1.0/",
    "http://www.scopemed.org/?page=license",
    "https://academic.oup.com/journals/pages/open_access/funder_policies/chorus/standard_publication_model",
    "https://creativecommons.org/licenses/by-nc-nd/4.0/",
    "https://creativecommons.org/licenses/by-nc-sa/4.0",
    "https://creativecommons.org/licenses/by-nc-sa/4.0/",
    "https://creativecommons.org/licenses/by/2.0",
    "https://creativecommons.org/licenses/by/3.0/",
    "https://creativecommons.org/licenses/by/4.0",
    "https://creativecommons.org/licenses/by/4.0/",
    "https://creativecommons.org/licenses/by/4.0/legalcode",
    "https://ieeexplore.ieee.org/Xplorehelp/downloads/license-information/USG.html",
    "https://iopscience.iop.org/info/page/text-and-data-mining",
    "https://online.boneandjoint.org.uk/TDM",
    "https://open.canada.ca/en/open-government-licence-canada",
    "https://royalsociety.org/-/media/journals/author/Licence-to-Publish-20062019-final.pdf",
    "https://royalsociety.org/journals/ethics-policies/data-sharing-mining/",
    "https://www.elsevier.com/open-access/userlicense/1.0/",
    "https://www.scientific.net/license/TDM_Licenser.pdf"];

 commercial_allowed = ["http://creativecommons.org/licenses/by-nd/4.0",
    "http://creativecommons.org/licenses/by-nd/4.0/",
    "http://creativecommons.org/licenses/by/2.0",
    "http://creativecommons.org/licenses/by/2.0/uk/legalcode",
    "http://creativecommons.org/licenses/by/3.0/",
    "http://creativecommons.org/licenses/by/3.0/deed.en_US",
    "http://creativecommons.org/licenses/by/3.0/pl/",
    "http://creativecommons.org/licenses/by/4.0",
    "http://creativecommons.org/licenses/by/4.0/",
    "http://opensource.org/licenses/AFL-3.0",
    "http://opensource.org/licenses/MIT",
    "http://pubs.acs.org/page/policy/authorchoice_ccby_termsofuse.html",
    "http://rightsstatements.org/vocab/NoC-US/1.0/",
    "https://creativecommons.org/licenses/by/2.0",
    "https://creativecommons.org/licenses/by/3.0/",
    "https://creativecommons.org/licenses/by/4.0",
    "https://creativecommons.org/licenses/by/4.0/",
    "https://creativecommons.org/licenses/by/4.0/legalcode",
    "https://ieeexplore.ieee.org/Xplorehelp/downloads/license-information/USG.html",
    "https://iopscience.iop.org/info/page/text-and-data-mining",
    "https://open.canada.ca/en/open-government-licence-canada"];

    showLicense(value) {
       console.log(value);
       return this.allowed.includes(value);
    }
}

export default new LicenseCheck();
